// src/routes/dashboardRoutes.tsx

import {
  Link,
  NavLink,
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";

import Dashboard from "../components/Dashboard/Dashboard";
import MiCuenta from "../components/Dashboard/Layout/MiCuenta/MiCuenta";
import Facturacion from "../components/Dashboard/Layout/Facturacion/Facturacion";
import MisCompras from "../components/Dashboard/Layout/MisCompras/MisCompras";
import ControlVideos from "../components/Dashboard/Layout/Videos/ControlVideos";
import Configuracion from "../components/Dashboard/Layout/Configuracion/Configuracion";
import Reportes from "../components/Dashboard/Layout/Reportes/Reportes";
import ReportesController from "../resource/web/controllers/reportes/ReportesController";
import ReporteController from "../resource/web/controllers/reportes/ReporteController";
import EventosController from "../resource/web/controllers/eventos/EventosController";
import EventoController from "../resource/web/controllers/eventos/EventoController";
import BoleteriaController from "../resource/web/controllers/eventos/BoleteriaController";
import UsuariosController from "../resource/web/controllers/usuarios/UsuariosController";
import UsuarioController from "../resource/web/controllers/usuarios/UsuarioController";
import CuponesController from "../resource/web/controllers/eventos/CuponesController";
import CuponController from "../resource/web/controllers/eventos/CuponController";
import MembresiasController from "../resource/web/controllers/membresias/MembresiasController";
import Sidebar from "../resource/web/components/menu/Sidebar";
import NotasController from "../resource/web/controllers/notas/NotasController";
import NotaController from "../resource/web/controllers/notas/NotaController";
import VideosController from "../resource/web/controllers/videos/VideosController";
import PerfilController from "../resource/web/controllers/perfil/PerfilController";
import FacturacionController from "../resource/web/controllers/facturacion/FacturacionController";

const AdminRoutes = [
  <Route
    path="/dashboard/perfil"
    element={
      <Sidebar>
        <PerfilController />
      </Sidebar>
    }
  />,
  <Route
    path="/dashboard/cuentas"
    element={
      <Sidebar>
        <Reportes />
      </Sidebar>
    }
  />,
  <Route
    path="/dashboard/facturacion"
    element={
      <Sidebar>
        <FacturacionController />
      </Sidebar>
    }
  />,
  <Route
    path="/dashboard/facturacion/:idEvento"
    element={
      <Sidebar>
        <Reportes />
      </Sidebar>
    }
  />,
  <Route
    path="/dashboard/videos"
    element={
      <Sidebar>
        <VideosController />
      </Sidebar>
    }
  />,
  <Route
    path="/dashboard/configuracion"
    element={
      <Sidebar>
        <Configuracion />
      </Sidebar>
    }
  />,
  <Route
    path="/dashboard/facturacion"
    element={
      <Sidebar>
        <Reportes />
      </Sidebar>
    }
  />,
  <Route
    path="/dashboard/reportes"
    element={
      <Sidebar>
        <ReportesController />
      </Sidebar>
    }
  />,
  <Route
    path="/dashboard/reportes/nuevo"
    element={
      <Sidebar>
        <ReporteController />
      </Sidebar>
    }
  />,
  <Route
    path="/dashboard/reportes/:id"
    element={
      <Sidebar>
        <ReporteController />
      </Sidebar>
    }
  />,
  <Route
    path="/dashboard/reportes/:id"
    element={
      <Sidebar>
        <ReporteController />
      </Sidebar>
    }
  />,

  <Route
    path="/dashboard/eventos"
    element={
      <Sidebar>
        <EventosController />
      </Sidebar>
    }
  />,
  <Route
    path="/dashboard/eventos/crear"
    element={
      <Sidebar>
        <EventoController />
      </Sidebar>
    }
  />,
  <Route
    path="/dashboard/eventos/:id"
    element={
      <Sidebar>
        <EventoController />
      </Sidebar>
    }
  />,

  <Route
    path="/dashboard/boleteria/:id"
    element={
      <Sidebar>
        <BoleteriaController />
      </Sidebar>
    }
  />,
  <Route
    path="/dashboard/boleteria/:id/:shared_token"
    element={<BoleteriaController />}
  />,
  <Route
    path="/dashboard/usuarios"
    element={
      <Sidebar>
        <UsuariosController />
      </Sidebar>
    }
  />,
  <Route
    path="/dashboard/usuarios/:id"
    element={
      <Sidebar>
        <UsuarioController />
      </Sidebar>
    }
  />,

  <Route
    path="/dashboard/cupones"
    element={
      <Sidebar>
        <CuponesController />
      </Sidebar>
    }
  />,
  <Route
    path="/dashboard/cupones/nuevo"
    element={
      <Sidebar>
        <CuponController />
      </Sidebar>
    }
  />,
  <Route
    path="/dashboard/cupones/:id"
    element={
      <Sidebar>
        <CuponController />
      </Sidebar>
    }
  />,
  <Route
    path="/dashboard/notas"
    element={
      <Sidebar>
        <NotasController />
      </Sidebar>
    }
  />,
  <Route
    path="/dashboard/nota/:id"
    element={
      <Sidebar>
        <NotaController />
      </Sidebar>
    }
  />,
  <Route
    path="/dashboard/membresias"
    element={
      <Sidebar>
        <MembresiasController />
      </Sidebar>
    }
  />,
];

export default AdminRoutes;
